// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientNotes_container__rIQX1","header":"ClientNotes_header__1SzI_","reportList":"ClientNotes_reportList__36u1Q"};